export interface Tab {
  name: string;
  hidden: boolean;
  widgets: any[];
}

export interface Dashboard {
  id: number;
  name: string;
  isFavorite: boolean;
  tabs: Tab[];
}

export const DASHBOARD_TABS = {
  KEY_METRICS: 'Key Metrics',
  CALL_OVERVIEW: 'Calls',
  AGENT_PERFORMANCE: 'Agents',
};

const DASHBOARD_KEY = 'dashboards';

export const DEFAULT_DASHBOARDS: Dashboard[] = [
  {
    id: 0,
    name: 'Default General',
    isFavorite: true,
    tabs: [
      {
        name: DASHBOARD_TABS.KEY_METRICS,
        hidden: false,
        widgets: []
      },
      {
        name: DASHBOARD_TABS.CALL_OVERVIEW,
        hidden: false,
        widgets: []
      },
      {
        name: DASHBOARD_TABS.AGENT_PERFORMANCE,
        hidden: false,
        widgets: []
      }
    ]
  },
  {
    id: 1,
    name: 'Sales',
    isFavorite: false,
    tabs: [
      {
        name: DASHBOARD_TABS.KEY_METRICS,
        hidden: false,
        widgets: []
      },
      {
        name: DASHBOARD_TABS.CALL_OVERVIEW,
        hidden: false,
        widgets: []
      },
      {
        name: DASHBOARD_TABS.AGENT_PERFORMANCE,
        hidden: false,
        widgets: []
      },
    ]
  },
  {
    id: 2,
    name: 'Support',
    isFavorite: false,
    tabs: [
      {
        name: DASHBOARD_TABS.KEY_METRICS,
        hidden: false,
        widgets: []
      },
      {
        name: DASHBOARD_TABS.CALL_OVERVIEW,
        hidden: false,
        widgets: []
      },
      {
        name: DASHBOARD_TABS.AGENT_PERFORMANCE,
        hidden: false,
        widgets: []
      },
    ]
  }
];

export function GetDashboards(): any[] {
  const dashboards = localStorage.getItem(DASHBOARD_KEY);
  return dashboards ? JSON.parse(dashboards) : DEFAULT_DASHBOARDS;
}

export function SaveDashboards(dashboards: any[]): void {
  localStorage.setItem(DASHBOARD_KEY, JSON.stringify(dashboards));
}

export function SetFavorite(id: number): void {
  const dashboards = GetDashboards();
  const updatedDashboards = dashboards.map(dashboard => {
    if (dashboard.id === id) {
      dashboard.isFavorite = true;
    }
    else {
      dashboard.isFavorite = false;
    }
    return dashboard;
  });
  SaveDashboards(updatedDashboards);
}

export function GetCurrentDashboard(): any {
  const dashboards = GetDashboards();
  const favorite = dashboards.find(d => d.isFavorite);
  return favorite || dashboards[0];
}
